import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiUri, API_URI } from "src/app/API_URI";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnquiryService {
  public openPopup$ = new BehaviorSubject(""); // open admin chat popup

  private apiUri: ApiUri;

  constructor(public http: HttpClient, @Inject(API_URI) apiUri: ApiUri) {
    this.apiUri = apiUri;
  }

  showChat(data) {
    this.openPopup$.next(data); // send data to admin popup
  }

  getEnquiry(): Observable<any> {
    return this.http.get(`${environment.apiUrl + this.apiUri.enquiry.GET}`);
  }
}
